import { Box } from '@mui/material';
import { Add } from '@mui/icons-material';
import {
  CustomAutoComplete,
  CustomButton,
  CustomCheckbox,
  CustomTextArea,
  DrawerFormSection,
  renderTwoLineOption,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS, drawerFieldSpan } from '../../../common/styles';
import { toArticleOptions } from '../../utils/toArticleOptions';
import { RETURN_ACTION_SX, RETURN_TEXTS as TEXTS } from '../constants/consumptionReturnTexts';

/** Selector de origen y su acción de agregar en una misma fila. */
const ConsumptionReturnOriginFields = ({
  form,
  sources,
  articles,
  searchArticle,
  sourceId,
  legacyArticleId,
  onSource,
  onArticle,
  onChange,
  onAdd,
  isSaving,
}) => (
  <DrawerFormSection title={TEXTS.origin}>
    <CustomCheckbox
      label={TEXTS.legacy}
      checked={form.legacy}
      disabled={isSaving}
      onChange={(event) => onChange('legacy', event.target.checked)}
      sx={drawerFieldSpan(12)}
    />
    <Box
      sx={{
        ...drawerFieldSpan(12),
        display: 'flex',
        alignItems: 'center',
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        gap: 1.5,
      }}
    >
      {form.legacy ? (
        <CustomAutoComplete
          label={TEXTS.article}
          value={legacyArticleId}
          disabled={isSaving}
          options={toArticleOptions(articles)}
          renderOption={renderTwoLineOption}
          inputPlaceholder={TEXTS.searchArticle}
          ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
          sx={{ flex: '1 1 240px', minWidth: 0, mt: 0 }}
          onInputChange={(_, value, reason) => {
            if (reason !== 'reset') searchArticle(value);
          }}
          filterOptions={(options) => options}
          onChange={(event) => onArticle(event.target.value)}
        />
      ) : (
        <CustomAutoComplete
          label={TEXTS.source}
          value={sourceId}
          disabled={isSaving}
          options={sources.filter((row) => row.available_quantity > 0).map((row) => ({
            value: row.uuid,
            label: row.article_name,
            secondary: `${row.consumption_number} · ${row.available_quantity}`,
          }))}
          renderOption={renderTwoLineOption}
          inputPlaceholder={TEXTS.source}
          ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
          onChange={(event) => onSource(event.target.value)}
          sx={{ flex: '1 1 240px', minWidth: 0, mt: 0 }}
        />
      )}
      <CustomButton
        variant="outlined"
        startIcon={<Add />}
        onClick={onAdd}
        disabled={isSaving || !(form.legacy ? legacyArticleId : sourceId)}
        sx={RETURN_ACTION_SX}
      >
        {TEXTS.add}
      </CustomButton>
    </Box>
    {form.legacy && (
      <CustomTextArea
        label={TEXTS.evidence}
        name="legacy_evidence"
        value={form.legacy_evidence}
        onChange={(event) => onChange('legacy_evidence', event.target.value)}
        disabled={isSaving}
        sx={drawerFieldSpan(12)}
      />
    )}
  </DrawerFormSection>
);

export default ConsumptionReturnOriginFields;
